import angular from 'angular';
import tinyColor from 'tinycolor2';
export class ColorService {
    toRGBA(hex, opacity = 1) {
        if (!hex) {
            return '';
        }
        const r = Number.parseInt(hex.slice(1, 3), 16);
        const g = Number.parseInt(hex.slice(3, 5), 16);
        const b = Number.parseInt(hex.slice(5, 7), 16);
        return `rgba(${r},${g},${b},${opacity})`;
    }
    toRGB(hex) {
        return {
            r: Number.parseInt(hex.slice(1, 3), 16),
            g: Number.parseInt(hex.slice(3, 5), 16),
            b: Number.parseInt(hex.slice(5, 7), 16),
        };
    }
    toRGBString(hex) {
        const color = {
            r: Number.parseInt(hex.slice(1, 3), 16),
            g: Number.parseInt(hex.slice(3, 5), 16),
            b: Number.parseInt(hex.slice(5, 7), 16),
        };
        return `rgb(${color.r},${color.g},${color.b})`;
    }
    toRGBValuesString(hex) {
        if (!hex) {
            return '';
        }
        const rgb = this.toRGB(hex);
        return `${rgb.r}, ${rgb.g}, ${rgb.b}`;
    }
    darken(color, percent) {
        return tinyColor(color).darken(percent).toString();
    }
    lighten(color, percent) {
        return tinyColor(color).lighten(percent).toString();
    }
    pickContrast(hex) {
        if (!hex) {
            return '#000000';
        }
        const rgb = this.toRGB(hex);
        return rgb.r * 0.299 + rgb.g * 0.587 + rgb.b * 0.114 > 186
            ? '#000000'
            : '#ffffff';
    }
    pickSidebarContrast(institution) {
        if (institution.contrastBack) {
            return institution.contrastBack;
        }
        const tinySidebarTextColor = tinyColor(institution.sidebarTextColor);
        return tinySidebarTextColor.isDark()
            ? tinySidebarTextColor.lighten(40).toString()
            : tinySidebarTextColor.darken(40).toString();
    }
    pickContrastBack(institution) {
        return (institution.contrastBack || this.pickContrast(institution.backgroundColor));
    }
    getColorFromGradient(gradientColors, percent = 65) {
        const width = 101;
        const height = 1;
        // Canvas
        const canvasElement = document.createElement('CANVAS');
        canvasElement.width = width;
        canvasElement.height = height;
        const context = canvasElement.getContext('2d');
        // Gradient
        const gradient = context.createLinearGradient(0, 0, width, 0);
        const step = 1 / (gradientColors.length - 1);
        for (const [index, color] of gradientColors.entries()) {
            gradient.addColorStop(step * index, color);
        }
        // Fill with gradient
        context.fillStyle = gradient;
        context.fillRect(0, 0, width, height);
        const color = context.getImageData(percent, 0, 1, 1);
        const rgba = color.data;
        return `rgb(${rgba[0]}, ${rgba[1]}, ${rgba[2]})`;
    }
}
export default angular
    .module('doxy.common.services.colorService', [])
    .service('colorService', ColorService).name;
